module.exports = __webpack_public_path__ + "img/complaint-m-banner.a2e27625.png";